import {createI18n} from 'vue-i18n';

const messages = {
    en: {
        general: {
            changeLanguage: "English Version",
            help: 'Instructions for use',
            menulabel: 'All content',
            shortcutMenuHeadline: 'Additional content',
            shortcutMenuBreak: 'How about a break?',
            shortcutImprint: 'Legal notice',
            shortcutImprintUrl: 'https://www.nrwglobalbusiness.com/legal-notice',
            shortcutPrivacy: 'Privacy policy',
            shortcutPrivacyUrl: 'https://www.nrwglobalbusiness.com/privacy-policy',
            shortcutAvatar: 'Change avatar',
            moreInformation: 'Read more',
            pointsOfInterest: 'Our Points of Interest',
            correct: 'Correct!',
            wrong: 'Sorry, wrong!',
            forward: 'Next',
            backwards: 'Previous'
        },
        share: {
            title: "The best location factors for NRW - discover them now in our 3D special",
            content: "Here is the link to the current page:"
        },
        sidebarIntro: {
            speechbubble_anim: 'How may we help you?',
            break_txt: 'How about a break?'
        },
        mainFooter: {
            bubble: 'Welcome to our digital NRW special! There is a lot to discover here about NRW as a business and innovation location. Please select one of the elements on the map and have fun exploring!',
            button: 'Let\'s go'
        },
        ControlsExplained: {
            controlElement1_part1: 'Left mouse button: ',
            controlElement1_part2: 'Hold ',
            controlElement1_part3: 'to rotate the map.',
            controlElement2_part1: 'Mouse wheel: ',
            controlElement2_part2: 'Scroll ',
            controlElement2_part3: 'to zoom the map.',
            controlElement3_part1: 'Left mouse button: ',
            controlElement3_part2: 'Click on the info box',
            controlElement3_part3: 'to explore a location.'

        },
        takeaBreak: {
            breakIntroStep1part1: 'It’s lunch time!',
            breakIntroStep1part2: 'A voyage of discovery like this gives you an appetite. Let\'s go out for something to eat!',
            breakIntroStep1response: 'Great idea. I\'m in!',
            breakIntroStep1_Evening: 'How time flies, it\'s already late. Enough work for today. Let\'s do something nice!',
            breakIntroStep1response_evening: 'I can hardly wait. So what do people get up to in NRW?',
            breakLaunchTimeFood_intro: 'These dishes are very popular in NRW – quite varied, aren\'t they? Choose what you would like to try.',
            breakLaunchTimeFood_item1: 'Currywurst with fries',
            breakLaunchTimeFood_item2: 'Japanese sushi',
            breakLaunchTimeFood_item3: 'Asparagus with potatoes',
            breakEvents_intro: 'In the evening, there are countless ways to round off the day. You can choose from our top 3. What do you fancy?',
            breakEvents_event1: 'Visit a brewery: get to know the drinking culture in NRW',
            breakEvents_event2: 'Go to a concert: a musical end to the day',
            breakEvents_event3: 'A trip to the funfair: traditional public festivals',
            breakFinish_line1: 'It\'s great that you were there.',
            breakFinish_line2: 'How should we proceed?',
            breakFinish_label1: 'Continue to the map',
            breakFinish_label2: 'Back to the selection',

        },
        formContent: {
            placeholder: 'Enter here',
            speechbubble_anim: 'Hi, we are team “NRW.Hero”. It\'s great that you want to explore NRW. What\'s your name?\n',
            Step1formLabel: 'Enter name',
            Step2formLabel: 'Your name',
            Step2formButton: 'Confirm entry',
            Step2formPlaceholder: 'Enter here',
            Step3form_intro1: '"Welcome to NRW, ',
            Step3form_intro2: 'Choose your avatar and let\'s get started!',
            Step3form_button: 'Confirm your choice',
            Step4form_intro1: 'Great, let\'s move on!',
            Step4form_intro2: 'How would you like to travel to NRW?',
            Step4form_bubble1: 'I travel by plane.',
            Step4form_bubble2: 'I travel by car.',
            Step4form_bubble3: 'I travel by train.',
            Step4form_button: 'Confirm your choice',
            Step5form_bubble1: 'Good choice, ',
            Step5form_bubble2: 'Today, we\'re  traveling by jetpack. Our meeting point: NRW!',
            Step5form_button: 'Start your journey',
            Step6form_button: 'Skip video'
        }

    },
    de: {
        general: {
            changeLanguage: "Deutsche Version",
            help: 'Hilfe',
            menulabel: 'Alle Inhalte',
            shortcutMenuHeadline: 'Weitere Inhalte',
            shortcutMenuBreak: 'Lust auf eine Pause?',
            shortcutImprint: 'Impressum',
            shortcutImprintUrl: 'https://www.nrwglobalbusiness.com/de/impressum',
            shortcutPrivacy: 'Datenschutz',
            shortcutPrivacyUrl: 'https://www.nrwglobalbusiness.com/de/datenschutzerklaerung',
            shortcutAvatar: 'Avatar wechseln',
            moreInformation: 'Mehr Informationen',
            pointsOfInterest: 'Unsere Points of Interest',
            correct: 'Richtig!',
            wrong: 'Leider falsch!',
            forward: 'Weiter',
            backwards: 'Zurück'
        },
        share: {
            title: "Die besten Standortfaktoren für NRW – Jetzt im 3D-Special entdecken!",
            content: "Hier ist der Link zur aktuellen Seite:"
        },
        sidebarIntro: {
            speechbubble_anim: 'Können wir Ihnen weiterhelfen?',
            break_txt: 'Lust auf eine Pause?'
        },
        mainFooter: {
            bubble: 'Herzlich willkommen in unserem digitalen NRW-Special! Hier gibt es viel zum Wirtschafts- und Innovationsstandort NRW zu entdecken. Bitte wählen Sie dafür eines der Elemente auf der Karte aus. Viel Spaß beim Erkunden!',
            button: 'Los geht\'s!',
        },
        ControlsExplained: {
            controlElement1_part1: 'Linke Maustaste: ',
            controlElement1_part2: 'Gedrückt halten,',
            controlElement1_part3: 'um die Karte zu drehen.',

            controlElement2_part1: 'Mausrad: ',
            controlElement2_part2: 'Scrollen,',
            controlElement2_part3: 'um die Karte zu zoomen.',

            controlElement3_part1: 'Linke Maustaste: ',
            controlElement3_part2: 'Klicken Sie auf die Infobox,',
            controlElement3_part3: 'um einen Ort zu erkunden.'

        },
        takeaBreak: {
            breakIntroStep1part1: 'It’s lunch time!',
            breakIntroStep1part2: 'So eine Entdeckungsreise macht hungrig. Lassen Sie uns etwas essen gehen!',
            breakIntroStep1response: 'Super Idee. Ich bin dabei!',
            breakIntroStep1_Evening: 'Wie die Zeit vergeht, es ist schon spät. Genug gearbeitet. Lassen Sie uns etwas Schönes unternehmen!',
            breakIntroStep1response_evening: 'Ich kann es kaum erwarten. Was macht man so in NRW?',
            breakLaunchTimeFood_intro: 'Diese Gerichte sind in NRW sehr beliebt – ganz schön abwechslungsreich, oder? Wählen Sie gleich mal aus, was Sie gerne probieren möchten.',
            breakLaunchTimeFood_item1: 'Currywurst mit Pommes',
            breakLaunchTimeFood_item2: 'Japanisches Sushi',
            breakLaunchTimeFood_item3: 'Spargel mit Kartoffeln',
            breakEvents_intro: '"Abends gibt es unzählige Möglichkeiten, den Tag ausklingen zu lassen. Sie können aus unseren Top 3 wählen. Worauf haben Sie Lust?"',
            breakEvents_event1: 'Besuch im Brauhaus: Trinkkultur in NRW kennenlernen',
            breakEvents_event2: 'Auf ein Konzert gehen: musikalischer Ausklang',
            breakEvents_event3: 'Ausflug auf die Kirmes: traditionelle Volksfeste',
            breakFinish_line1: 'Schön, dass Sie dabei waren.',
            breakFinish_line2: 'Wie soll es weitergehen?',
            breakFinish_label1: 'Weiter zur Karte',
            breakFinish_label2: 'Zurück zur Auswahl',

        },
        formContent: {
            placeholder: 'Hier eingeben',
            speechbubble_anim: 'Hallo, wir sind Team "NRW.Hero". Schön, dass Sie NRW erkunden möchten. Wie heißen Sie?',
            Step1formLabel: 'Name eingeben',
            Step2formLabel: 'Ihr Name',
            Step2formButton: 'Eingabe bestätigen',
            Step2formPlaceholder: 'Hier eingeben',
            Step3form_intro1: '"Herzlich willkommen in NRW, ',
            Step3form_intro2: 'Wählen Sie Ihren Avatar aus und lassen Sie uns direkt loslegen!',
            Step3form_button: 'Auswahl bestätigen',
            Step4form_intro1: 'Super, weiter geht´s!',
            Step4form_intro2: 'Wie möchten Sie nach NRW reisen?',
            Step4form_bubble1: 'Ich reise mit dem Flugzeug.',
            Step4form_bubble2: 'Ich reise mit dem Auto.',
            Step4form_bubble3: 'Ich reise mit der Bahn.',
            Step4form_button: 'Auswahl bestätigen',
            Step5form_bubble1: 'Gute Wahl,',
            Step5form_bubble2: 'Wir sind heute mit dem Jetpack unterwegs. Unser Treffpunkt: NRW!',
            Step5form_button: 'Reise beginnen',
            Step6form_button: 'Video überspringen'
        },

    },
    ja: {
        general: {
            changeLanguage: "日本語版",
            help: 'ヘルプ',
            menulabel: 'すべてのコンテンツ',
            shortcutMenuHeadline: 'その他のコンテンツ',
            shortcutMenuBreak: '休憩しましょうか？',
            shortcutImprint: 'インプリント',
            shortcutImprintUrl: 'https://www.nrwglobalbusiness.com/ja/%E3%82%A4%E3%83%B3%E3%83%97%E3%83%AA%E3%83%B3%E3%83%88',
            shortcutPrivacy: '個人情報保護',
            shortcutPrivacyUrl: 'https://www.nrwglobalbusiness.com/ja/%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E4%BF%9D%E8%AD%B7%E6%96%B9%E9%87%9D',
            shortcutAvatar: 'アバターを変える',
            moreInformation: 'もっと詳しく',
            pointsOfInterest: 'NRW州にはこんなものがある…',
            correct: '正解！',
            wrong: '残念！',
            forward: 'さらに',
            backwards: 'バック'
        },
        share: {
            title: "ここがすごい！ NRW州の立地拠点ファクターを3Dで見てみましょう！",
            content: "サイトへ"
        },
        sidebarIntro: {
            speechbubble_anim: '他に何かお手伝いできることあるかな？',
            break_txt: '休憩しましょうか？'
        },
        mainFooter: {
            bubble: '"デジタルNRW州スペシャルへようこそ！ ここでは、ビジネスとイノベーションの拠点NRW州についてたくさんのことが発見できるよ。バーチャル・マップ上の気になるアイテムをクリックしてみて！楽しんで探検してね！"\n',
            button: '冒険を始める',
        },
        ControlsExplained: {
            controlElement1_part1: '左クリック: ',
            controlElement1_part2: '',
            controlElement1_part3: 'マウスボタンを長押しするとマップが回転します',

            controlElement2_part1: 'マウスホイール: ',
            controlElement2_part2: '',
            controlElement2_part3: 'スクロールするとズームイン・ズームアウトします',

            controlElement3_part1: '左クリック: ',
            controlElement3_part2: '',
            controlElement3_part3: '「吹き出し」をクリックすると各々の詳細な情報が見られます'

        },
        takeaBreak: {
            breakIntroStep1part1: 'もうランチタイムね！',
            breakIntroStep1part2: 'こんな発見の旅をしているとお腹が空いてくるわね。何か食べに行きましょうよ！',
            breakIntroStep1response: '素敵な考えだ。一緒に行く！',
            breakIntroStep1_Evening: '時間が経つのは早いもので、もうこんな時間なんだね。十分働いたよ。何か楽しいことしようよ！',
            breakIntroStep1response_evening: '楽しいことって？ NRW州には何があるの？',
            breakLaunchTimeFood_intro: 'この料理はNRW州でとても人気があるんだ。食べてみたいものを選んでみてね。',
            breakLaunchTimeFood_item1: 'カリーヴルスト',
            breakLaunchTimeFood_item2: '寿司',
            breakLaunchTimeFood_item3: 'ホワイトアスパラガスのポテト添え',
            breakEvents_intro: '一日を締めくくる、色々なチョイスが夜はたくさんあるんだ。トップ3から選んでみてよ。何がいいかな？',
            breakEvents_event1: 'ビール醸造所を訪れる: NRW州の飲酒文化を知る',
            breakEvents_event2: 'コンサートに行く: 音楽 で一日の終わりを楽しむ',
            breakEvents_event3: 'お祭りに出かける: 伝統的なフォークフェスティバル',
            breakFinish_line1: 'ここまで一緒にいてくれてありがとう',
            breakFinish_line2: '次はどうしましょうか？',
            breakFinish_label1: 'バーチャル・マップに戻る',
            breakFinish_label2: '選択に戻る',

        },
        formContent: {
            placeholder: 'ここに入力',
            speechbubble_anim: 'こんにちは！ 私たちはチーム「NRW.Hero」よ。NRW州を探検したいって言ってくれてうれしいな。あなたの名前は？',
            Step1formLabel: '名前を入力',
            Step2formLabel: '名前',
            Step2formButton: '確定してください',
            Step2formPlaceholder: '入力',
            Step3form_intro1: 'NRW州へようこそ、',
            Step3form_intro2: 'さん！アバターを選んで、さっそく始めよう！',
            Step3form_button: '確定してください',
            Step4form_intro1: 'よし、次のステップだ！',
            Step4form_intro2: '何に乗ってNRW州を冒険する？',
            Step4form_bubble1: '飛行機で！',
            Step4form_bubble2: '車で！',
            Step4form_bubble3: '電車で！',
            Step4form_button: '確定してください',
            Step5form_bubble1: 'いい選択だね、',
            Step5form_bubble2: 'さん！私たちはジェットパックで空をひとっ飛びするから、NRW州で集合しましょうね！',
            Step5form_button: '冒険を始める',
            Step6form_button: 'ビデオをスキップする'
        },

    },
    cn: {
        general: {
            changeLanguage: "Chinesische Version",
            help: '帮助',
            menulabel: '全部内容',
            shortcutMenuHeadline: '其他内容',
            shortcutMenuBreak: '想暂停休息一下？',
            shortcutImprint: '版权说明',
            shortcutImprintUrl: 'https://www.nrwglobalbusiness.com/cn/legal-notice',
            shortcutPrivacy: '数据保护',
            shortcutPrivacyUrl: 'https://www.nrwglobalbusiness.com/cn/privacy-policy',
            shortcutAvatar: '更换头像',
            moreInformation: '更多信息',
            pointsOfInterest: '我们的风景名胜',
            correct: '正确！',
            wrong: '很遗憾，错误',
            forward: '更多',
            backwards: '返回'
        },
        share: {
            title: "北威州最佳区位因素——三维视角，立即体验！",
            content: "这里是实时页面访问链接："
        },
        sidebarIntro: {
            speechbubble_anim: ' 我们可以帮助您吗？',
            break_txt: '想休息一下吗？'
        },
        mainFooter: {
            bubble: '欢迎浏览北威州数字特刊！在这里您可以发现北威州在商业和创新领域的很多信息。请选择地图上其中一个元素。祝您探索愉快！',
            button: '我们走吧',
        },
        ControlsExplained: {
            controlElement1_part1: '鼠标左键: ',
            controlElement1_part2: '按住不放可旋转地图。',
            controlElement1_part3: '',

            controlElement2_part1: '鼠标滚轮: ',
            controlElement2_part2: '滚动可放大或缩小地图。',
            controlElement2_part3: '',

            controlElement3_part1: '鼠标左键: ',
            controlElement3_part2: '点击信息框，探索一个地点。',
            controlElement3_part3: ''

        },
        takeaBreak: {
            breakIntroStep1part1: '午餐时间到了！',
            breakIntroStep1part2: '这样的探索之旅真是让人饥肠辘辘。我们出去吃点东西吧！',
            breakIntroStep1response: '好主意。我加入！',
            breakIntroStep1_Evening: '时间过得真快，已经很晚了。工作时间够长了，让我们做点有趣的事情吧！',
            breakIntroStep1response_evening: '我都等不及了。在北威州都能做些什么呢？',
            breakLaunchTimeFood_intro: '男主角/女主角：这些菜肴在北威州非常受欢迎。 种类相当丰富，不是吗？现在就选择您想品尝的菜肴吧。',
            breakLaunchTimeFood_item1: '咖喱香肠配薯条',
            breakLaunchTimeFood_item2: '日本寿司',
            breakLaunchTimeFood_item3: '芦笋配土豆',
            breakEvents_intro: '"晚上，有无数种方式为一天画上圆满的句号。您可以从我们的前三大推荐项目中进行选择。您对哪项感兴趣？"',
            breakEvents_event1: '参观啤酒厂：了解北威州的饮酒文化； ',
            breakEvents_event2: '听一场音乐会：音乐压轴戏',
            breakEvents_event3: '逛游乐园：传统民俗节日',
            breakFinish_line1: '很高兴与您一起完成本次体验。',
            breakFinish_line2: '接下来该去哪里？',
            breakFinish_label1: '继续访问地图',
            breakFinish_label2: '返回选项菜单',

        },
        formContent: {
            placeholder: '在此处输入',
            speechbubble_anim: '您好，我们是“NRW.Hero”团队。很高兴您愿意探索北威州。您叫什么名字？',
            Step1formLabel: '输入姓名',
            Step2formLabel: '您的姓名',
            Step2formButton: '确认输入',
            Step2formPlaceholder: '在此处输入',
            Step3form_intro1: '""欢迎来到北威州, ',
            Step3form_intro2: '请选择您的头像，让我们马上开始吧！',
            Step3form_button: '确认选择',
            Step4form_intro1: '太棒了，我们继续！',
            Step4form_intro2: '您想如何前往北威州？',
            Step4form_bubble1: '我乘坐飞机去。',
            Step4form_bubble2: '我乘坐汽车去。',
            Step4form_bubble3: '我乘坐火车去。',
            Step4form_button: '确认选择',
            Step5form_bubble1: '选得好,',
            Step5form_bubble2: '我们今天乘坐喷气背包旅行。我们的集合地：北威州！',
            Step5form_button: '开始旅行',
            Step6form_button: '跳过视频'
        },

    },
    tr: {
        general: {
            changeLanguage: "Türkçe versiyon",
            help: 'Yardım',
            menulabel: 'Tüm içerikler',
            shortcutMenuHeadline: 'Daha fazla içerik',
            shortcutMenuBreak: 'Biraz mola vermek ister misiniz?',
            shortcutImprint: 'Künye',
            shortcutImprintUrl: 'https://www.nrwglobalbusiness.com/tr/kuenye',
            shortcutPrivacy: 'Veri koruma',
            shortcutPrivacyUrl: 'https://www.nrwglobalbusiness.com/tr/veri-koruma-beyannamesi',
            shortcutAvatar: 'Avatar değiştirin',
            moreInformation: 'Daha fazla bilgi',
            pointsOfInterest: 'İlgi çekici noktalarımız',
            correct: 'Doğru!',
            wrong: 'Ne yazık ki yanlış!',
            forward: 'Daha ileri',
            backwards: 'Geri'
        },
        share: {
            title: "NRW için en iyi konum faktörleri - Özel 3 Boyutlu ortamda şimdi keşfedin!",
            content: "İşte güncel sayfanın bağlantısı:"
        },
        sidebarIntro: {
            speechbubble_anim: 'Size başka nasıl yardımcı olabiliriz?',
            break_txt: 'Mola vermek ister misin?'
        },
        mainFooter: {
            bubble: 'Dijital NRW-Special’a hoş geldiniz! Burada bir ekonomi ve inovasyon merkezi olan Kuzey Ren-Vestfalya hakkında keşfedilecek çok şey var. Lütfen haritadaki öğelerden birini seçin. Keyifli keşifler!',
            button: 'Hadi gidelim!',
        },
        ControlsExplained: {
            controlElement1_part1: 'Sol fare tuşu: ',
            controlElement1_part2: 'Haritayı çevirmek için',
            controlElement1_part3: 'basılı tutun.',

            controlElement2_part1: 'Fare tekeri: ',
            controlElement2_part2: 'Haritada yakınlaşmak',
            controlElement2_part3: 'için kaydırın.',

            controlElement3_part1: 'Sol fare tuşu: ',
            controlElement3_part2: 'Bir yeri keşfetmek için',
            controlElement3_part3: 'bilgi kutusuna tıklayın.'

        },
        takeaBreak: {
            breakIntroStep1part1: 'Öğle Yemeği',
            breakIntroStep1part2: 'zamanı! Böyle bir keşif yolculuğu insanı acıktırıyor. Hadi bir şeyler yiyelim!',
            breakIntroStep1response: 'Süper fikir. Bana uyar!',
            breakIntroStep1_Evening: 'Zaman nasıl da geçiyor, akşam oldu bile. Yeterince çalıştık. Hadi eğlenceli bir şeyler yapalım!',
            breakIntroStep1response_evening: 'Sabırsızlanıyorum. NRW\'de insanlar ne yapıyor?',
            breakLaunchTimeFood_intro: 'Bu yemekler NRW\'de çok popüler - oldukça çeşitli, değil mi? Şimdi ne denemek istediğinizi seçin.',
            breakLaunchTimeFood_item1: 'Sosis ve patates kızartması',
            breakLaunchTimeFood_item2: 'Japon suşisi',
            breakLaunchTimeFood_item3: 'Kuşkonmaz ve patates',
            breakEvents_intro: '"Akşamları, günü tamamlamanın sayısız yolu vardır. En iyi 3 ürünümüzden birini seçebilirsiniz. Ne istersiniz?"',
            breakEvents_event1: 'Bira fabrikasına ziyaret: NRW\'deki içki kültürünü tanıma',
            breakEvents_event2: 'Konsere gitme: müzikal bir final',
            breakEvents_event3: 'Konsere gitme: müzikal bir final',
            breakFinish_line1: 'Bize katıldığınız için teşekkür ederiz.',
            breakFinish_line2: 'Sırada ne var?',
            breakFinish_label1: '3D Haritaya devam edin',
            breakFinish_label2: 'Seçiminize geri dönün',

        },
        formContent: {
            placeholder: 'Buraya giriniz',
            speechbubble_anim: 'Merhaba, biz “NRW.Hero” ekibiyiz. NRW’yi keşfetmek istemeniz ne güzel. Adınız ne?',
            Step1formLabel: 'İsim giriniz',
            Step2formLabel: 'Adınız',
            Step2formButton: 'Girişi onaylayın',
            Step2formPlaceholder: 'Buraya giriniz',
            Step3form_intro1: '"NRW’ye hoş geldiniz!, ',
            Step3form_intro2: 'Avatarınızı seçip hemen başlayın!',
            Step3form_button: 'Seçiminizi onaylayın',
            Step4form_intro1: 'Harika, haydi devam!',
            Step4form_intro2: 'NRW’ye nasıl seyahat etmek istersiniz?',
            Step4form_bubble1: 'Uçakla seyahat ederim.',
            Step4form_bubble2: 'Arabayla seyahat ederim.',
            Step4form_bubble3: 'Trenle seyahat ederim.',
            Step4form_button: 'Seçiminizi onaylayın',
            Step5form_bubble1: 'İyi bir seçimdi,',
            Step5form_bubble2: 'Bugün Jetpack ile yollardayız. Buluşma noktamız: NRW!',
            Step5form_button: 'Seyahate başlayın',
            Step6form_button: 'Videoyu atlayın'
        },

    }
};

const i18n = createI18n({
    locale: 'de', // Standardmäßig eingestellte Sprache
    fallbackLocale: 'de', // Ausweichsprache, falls keine Übersetzung gefunden wird
    messages,
});

export default i18n;
